// extracted by mini-css-extract-plugin
export default {"root":"BlockCard_root__wrmI7","appear":"BlockCard_appear__gac9o","appearAnimation":"BlockCard_appearAnimation__vscOj"};